import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ReportAccess } from '@bunker/shared';

const FALLBACK: ReportAccess = { platformAdmin: false, rootAdmin: false };

/**
 * What moderation surfaces the current user may open. Drives whether the
 * "Модерация Бункера" settings tab + team panel show. Cheap, cached for the
 * session — the answer only changes when a root admin (re)assigns the user.
 */
export function useReportAccess(): ReportAccess {
  const q = useQuery({
    queryKey: ['reports', 'access'],
    queryFn: () => api.getReportAccess(),
    staleTime: 5 * 60 * 1000,
  });
  return q.data ?? FALLBACK;
}
